import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Application from './application/routes/home';
import PasswordChange from './application/routes/passwordChange';

const MainRoutes = () => {
  return (
    <Routes>
      <Route
        path="/passwordchange/:token"
        element={<PasswordChange />}
      />
      <Route
        path="/"
        element={<Application />}
      />
      <Route
        path="*"
        element={<Application />}
      />
    </Routes>
  );
};

export default MainRoutes;
